// One brand everywhere: the product is GAMEDAY Courtside, made by HoopsHQ, and HoopsHQ.net is its home.
export const BRAND = "GAMEDAY Courtside by HoopsHQ";
export const SITE = "HoopsHQ.net";

export const BrandLine = ({ className = "", testid = "brand-line" }) => (
  <p data-testid={testid} className={`font-mono-gd text-xs uppercase tracking-[0.2em] text-slate-400 ${className}`}>
    GAMEDAY Courtside <span className="text-slate-300">by HoopsHQ</span> · <span className="text-[#39FF14]">{SITE}</span>
  </p>
);
